import React, { useEffect, useRef, useState } from 'react';

import { Chip, Stack, Tooltip, Typography } from '@mui/material';

import OverflowTip from '../Components/OverflowTip';
import PopoverPopupState from '../Components/Popups/PopoverPopupState';

interface IProps {
  list: any[];
  chipColor?: string;
  labelKey?: string;
  valueKey?: string;
  onClick?: (value: any) => void;
  id: string;
  title?: string;
  width?: string;
}

const TableChipList = ({
  list,
  chipColor,
  labelKey = 'name',
  valueKey = 'name',
  onClick,
  id,
  title,
  width,
}: IProps) => {
  const chipLabel = labelKey ? list?.[0]?.[labelKey] : list?.[0];
  const chipValue = valueKey ? list?.[0]?.[valueKey] : list?.[0];
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowed(
        textRef.current.scrollWidth > textRef.current.clientWidth
      );
    }
  }, [chipLabel, width]);

  return (
    <Stack
      direction="row"
      height="-webkit-fill-available"
      spacing={0.25}
      sx={{ alignItems: 'center' }}
    >
      {chipLabel ? (
        <Tooltip
          key={chipLabel}
          title={
            list?.[0]?.active_status === false
              ? 'Inactive'
              : isOverflowed
                ? chipLabel
                : ''
          }
        >
          <Chip
            sx={{
              background: chipColor || '#C4DBFF',
              color: 'riSecondary.900',
              ...(list?.[0]?.active_status === false && {
                background: '#e0e0e0',
              }),
              maxWidth: width || '260px', // set max width
              overflow: 'hidden', // hide overflow
              textOverflow: 'ellipsis', // add ...
              whiteSpace: 'nowrap', // prevent wrapping
            }}
            label={
              <span
                ref={textRef}
                style={{
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '100%',
                  marginTop: 5,
                }}
              >
                {chipLabel}
              </span>
            }
            onClick={() => onClick?.([chipValue])}
          />
        </Tooltip>
      ) : (
        '_'
      )}
      {list.length > 1 && (
        <PopoverPopupState
          id={id}
          renderIcon={() => (
            <Typography
              key="2"
              sx={{
                color: 'riNeutralVariant.700',
                fontSize: '11px',
              }}
            >
              {list.length - 1}+
            </Typography>
          )}
        >
          <Stack spacing={2}>
            {title && <Typography fontSize="15px">{title}</Typography>}
            <Stack
              direction="row"
              spacing={1}
              flexWrap="wrap"
              maxWidth="200px"
              gap="10px"
            >
              {list?.map((item: any, index: number) => {
                const chipLabel = labelKey ? item[labelKey] : item;
                const chipValue = valueKey ? item[valueKey] : item;

                return (
                  index !== 0 && (
                    <Tooltip
                      key={index}
                      title={
                        item?.active_status === false ? 'Inactive' : chipLabel
                      }
                    >
                      <Chip
                        sx={{
                          background: chipColor || '#C4DBFF',
                          color: 'riSecondary.900',
                          ...(item?.active_status === false && {
                            background: '#e0e0e0',
                          }),
                        }}
                        label={<OverflowTip value={chipLabel} />}
                        onClick={() => {
                          if (onClick) {
                            onClick([chipValue]);
                          }
                        }}
                      />
                    </Tooltip>
                  )
                );
              })}
            </Stack>
          </Stack>
        </PopoverPopupState>
      )}
    </Stack>
  );
};

export default TableChipList;
